import { useCallback } from 'react';
import { PathwayScenarioOutletContext } from '@/types';
import { useOutletContext } from 'react-router-dom';
import { Content, useToast } from '@kinesis/bungle';
import { Loading } from '@/components/loading';
import { PathwayScenarioOutputs } from '@/components/scenario-outputs';
import {
  useSimulationQuery,
  useDownloadPathwayScenarioMutation,
} from '@/api/pathway-scenarios';
import { usePathwayScenarioId } from '@/hooks/use-scenario-id';

const PathwayScenarioSimulation = () => {
  const scenarioId = usePathwayScenarioId();
  const toast = useToast('globalTop');
  const { scenario } = useOutletContext<PathwayScenarioOutletContext>();
  const [downloadPathwayScenario, { isLoading: isDownloading }] =
    useDownloadPathwayScenarioMutation();
  const { data: simulation, isLoading: isLoadingSimulation } =
    useSimulationQuery({ scenarioId, interventions: scenario.interventions });

  const onDownload = useCallback(async () => {
    try {
      await downloadPathwayScenario({
        scenarioId,
        interventions: scenario.interventions,
      }).unwrap();
    } catch (e) {
      toast('Could not download scenario.', { variant: 'error' });
    }
  }, [toast, downloadPathwayScenario, scenarioId, scenario]);

  if (isLoadingSimulation) {
    return <Loading />;
  }
  if (!isLoadingSimulation && simulation) {
    return (
      <Content padding='medium'>
        <PathwayScenarioOutputs
          simulation={simulation}
          onDownload={onDownload}
          downloading={isDownloading}
        />
        ;
      </Content>
    );
  }
  return null;
};

export { PathwayScenarioSimulation };
